import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpleadoVincularusuarioComponent {
  guardando = false
  idColaborador
  idProyecto
  mostrarvinculacion = false
  onVincular
  usuario

  constructor (ViaticosUsuarios, ViaticosProyectosColaboradorUsuario) {
    this.ViaticosUsuarios = ViaticosUsuarios
    this.ViaticosProyectosColaboradorUsuario = ViaticosProyectosColaboradorUsuario
  }

  $onInit () {
    this.ViaticosUsuarios.get().then(({data}) => (this.usuarios = data))
  }

  vincular () {
    this.guardando = true
    this.ViaticosProyectosColaboradorUsuario.post(this.idProyecto, this.idColaborador, this.usuario)
      .then(() => {
        this.guardando = false
        this.onVincular()
      })
  }
}

module.component('viaticosConfiguracionEmpleadoVincularusuario', {
  controller: ViaticosConfiguracionEmpleadoVincularusuarioComponent,
  template,
  bindings: {
    idColaborador: '<',
    idProyecto: '<',
    onVincular: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empleado/vincularusuario/component.js